import { render, staticRenderFns } from "./DocsSidebar.vue?vue&type=template&id=41de40ef&scoped=true&lang=pug&"
import script from "./DocsSidebar.vue?vue&type=script&lang=ts&"
export * from "./DocsSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de40ef",
  null
  
)

export default component.exports